import React, { useState } from "react";
import { Form, Input, Select, Upload, Button, message } from "antd";
import DashboardBreadcrumb from "../../components/layout/DashboardBreadcrumb";
import { Content } from "antd/lib/layout/layout";
import { useDispatch, useSelector } from "react-redux";
import EditProfileApi from "../../api/users/EditProfileApi";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../helpers/NotificationHelpers";
import { userDetails } from "../../features/UserSlice";

import { UploadProfileApi } from "../../api/UploadProfileApi";
import ImgCrop from "antd-img-crop";
import { DeleteOutlined } from "@ant-design/icons";
import DeleteProfileApi from "../../api/DeleteProfileApi";

const { Option } = Select;

function UserProfile() {
  const proHeight = document.body.clientHeight;
  const [submit, setSubmit] = useState(false);
  const userState = useSelector((state) => state.userState.value);
  const dispatch = useDispatch();
  const [imageUrl, setImageUrl] = useState("");
  const [newImageUrl, setNewImageUrl] = useState("");
  const [valuesChanged, setValuesChanged] = useState(false);

  const [fields, setFields] = useState([
    {
      name: ["firstName"],
      value: userState.firstName || "",
    },
    {
      name: ["lastName"],
      value: userState.lastName || "",
    },
    {
      name: ["phoneNumber"],
      value: userState?.phone?.substring(3) || "",
    },
    {
      name: ["country"],
      value: userState.country || "",
    },
    {
      name: ["address"],
      value: userState.address || "",
    },
    {
      name: ["gender"],
      value: userState.gender || "",
    },
  ]);

  const left = (
    <>
      <div className="pri-font text-lg">Your Profile</div>
    </>
  );
  async function onFinish(values) {
    setSubmit(true);
    let phone = values.phoneNumber;
    if (phone.charAt(0) === "0") {
      phone = phone.slice(1);
    }
    const apiResponse = await EditProfileApi(
      userState.id,
      values.firstName,
      values.lastName,
      values.country,
      values.address,
      values.City,
      values.gender,
      values.phoneNumber === "" ? "" : values.phoneCode + phone,
      imageUrl ? imageUrl : values.image
    );

    if (apiResponse.error) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.success) {
      dispatch(userDetails(apiResponse.data));
      openNotificationSuccess("bottomRight", "Profile updated successfully");
      setSubmit(false);
    } else {
      openNotificationError("bottomRight", "Couldn't update. Try again later.");
    }
    setSubmit(false);
    setValuesChanged(false);
  }

  async function upload(file, name) {
    setSubmit(true);
    const apiResponse = await UploadProfileApi(file, name);
    if (apiResponse.statusCode) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.message === "success") {
      setImageUrl(apiResponse.url);
    }
    setSubmit(false);
  }

  function beforeUpload(file) {
    const isJpgOrPng =
      file.type === "image/jpeg" ||
      file.type === "image/png" ||
      file.type === "image/jpg";
    if (!isJpgOrPng) {
      message.info("You can only upload JPG/PNG file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.info("Image must smaller than 2MB!");
    }
    return isJpgOrPng && isLt2M;
  }
  const beforeUpload2 = async (info) => {
    await upload(info, userState.id);
    getBase64(info, (imageUrl) => {
      setNewImageUrl(imageUrl);
    });
    return false;
  };

  function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  async function deleteProfile() {
    const apiResponse = await DeleteProfileApi(userState.id);
    if (apiResponse.success) {
      dispatch(userDetails(apiResponse.data.userResponse));
      setValuesChanged(false);
    }
  }

  const prefixSelector = (
    <Form.Item name="phoneCode" noStyle>
      <Select style={{ width: 70 }}>
        <Option value="94">+94</Option>
        <Option value="91">+91</Option>
      </Select>
    </Form.Item>
  );

  return (
    <>
      <Content style={{ backgroundColor: "#fff" }}>
        <DashboardBreadcrumb left={left} />
        <div
          style={{
            height: proHeight - 122,
            overflow: "auto",
          }}
          className="custom-scroll p-6"
        >
          <div className="max-w-xl">
            <Form
              onValuesChange={() => {
                setValuesChanged(true);
              }}
              name="userProfile"
              onFinish={onFinish}
              initialValues={{
                phoneCode: "+94",
              }}
              layout="vertical"
              requiredMark={false}
              scrollToFirstError
              fields={fields}
            >
              <Form.Item name="image" initialValue={userState.imageUrl}>
                <div className="">
                  <div className="flex items-center">
                    <div className="w-28 h-28 bg-gray-200 rounded-full overflow-hidden justify-center flex items-center mb-3 text-gray-400 text-3xl">
                      {newImageUrl || imageUrl || userState.imageUrl ? (
                        <img
                          src={
                            newImageUrl
                              ? newImageUrl
                              : imageUrl
                              ? imageUrl
                              : userState.imageUrl
                          }
                          alt="avatar"
                          className="w-28 h-28"
                        />
                      ) : (
                        userState?.firstName?.charAt(0)
                      )}
                    </div>
                    <div className="ml-3 flex items-center ">
                      <ImgCrop beforeCrop={beforeUpload}>
                        <Upload
                          name="profile"
                          showUploadList={false}
                          beforeUpload={beforeUpload2}
                          // onChange={handleChange}
                        >
                          <Button>
                            {" "}
                            {newImageUrl || imageUrl || userState.imageUrl
                              ? "Change profile"
                              : "Add profile"}
                          </Button>
                        </Upload>
                      </ImgCrop>
                      {newImageUrl || imageUrl || userState.imageUrl ? (
                        <div className=" text-red-500 cursor-pointer ml-3">
                          <DeleteOutlined
                            onClick={() => {
                              setImageUrl("");
                              setNewImageUrl("");
                              deleteProfile();
                            }}
                          />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </Form.Item>
              <Form.Item
                name="firstName"
                label="First name"
                rules={[
                  {
                    required: true,
                    message: "Please enter first name!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item
                name="lastName"
                label="Last name"
                rules={[
                  {
                    required: true,
                    message: "Please enter last name!",
                  },
                ]}
              >
                <Input />
              </Form.Item>
              <Form.Item name="country" label="Country">
                <Input />
              </Form.Item>

              <Form.Item name="phoneNumber" label="Phone Number">
                <Input addonBefore={prefixSelector} style={{ width: "100%" }} />
              </Form.Item>

              <Form.Item name="address" label="Address">
                <Input.TextArea />
              </Form.Item>
              <Form.Item>
                <Button
                  className="btn w-40"
                  type="primary"
                  htmlType="submit"
                  disabled={submit || !valuesChanged}
                >
                  Save
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </Content>
    </>
  );
}

export default UserProfile;
